import { render, staticRenderFns } from "./TaskColumn.vue?vue&type=template&id=6a2223bb&scoped=true&"
import script from "./TaskColumn.vue?vue&type=script&lang=js&"
export * from "./TaskColumn.vue?vue&type=script&lang=js&"
import style0 from "./TaskColumn.vue?vue&type=style&index=0&id=6a2223bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2223bb",
  null
  
)

export default component.exports